<ng-template #sidebarTemplate>
    <ig-row class="login-with-fb">
        <ig-col [xs]="6">
            <span>EVENTS</span>
        </ig-col>
        <ig-col [xs]="6">
            <ig-fb-login-btn #loginWithFBBtn (onLoginStatusChanged)="initFacebookStatus()"></ig-fb-login-btn>
        </ig-col>
    </ig-row>

    <div class="top-btn-group">
        <ig-row>
            <ig-col [xs]="featuresToggle.placeCalendar?6:12">
                <ig-button class="event-btn" (trigger)="gotoEventCalendar()">EVENTS</ig-button>
            </ig-col>

            <ig-col [xs]="6" *ngIf="featuresToggle.placeCalendar">
                <ig-button class="place-btn" (trigger)="gotoPlaceCalendar()">PLACES</ig-button>
            </ig-col>
        </ig-row>
    </div>

    <div class="back-to-list">
        <span (click)="gotoEventCalendar()">GO BACK TO EVENT LIST</span>
    </div>

    <p class="event-title">{{ event?.title }}</p>
    <p class="event-host" *ngIf="event?.owner">Event created by
        <span>
            <a *ngIf="event?.hostLink&&event?.hostLink!=='undefined'" href="{{event?.hostLink}}"
               target="_blank">{{ event?.owner.name }}</a>
            <span *ngIf="!event?.hostLink||event?.hostLink==='undefined'">{{ event?.owner.name }}</span>
        </span>
    </p>

    <div class="img-wrap">
        <img (click)="jumpFacebook()" [src]="imageService.safeImage(imageService.imageSource(event))" alt="event image">
    </div>

    <div class="event-info">
        <ig-row>
            <ig-col [xs]="1">
                <mat-icon>date_range</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <div *ngIf="event?.eventTimes&&event?.eventTimes.length">
                    <p *ngFor="let eventTime of event?.eventTimes">
                        {{ eventTime.startTimeFormatted }}
                        {{ eventTime.endTimeFormatted ? ' - ' + eventTime.endTimeFormatted : '' }}
                    </p>

                </div>
                <div *ngIf="!event?.eventTimes||!event?.eventTimes.length">
                    <p>{{ event?.startTimeFormatted }}
                        {{ event?.endTimeFormatted ? ' - ' + event?.endTimeFormatted : '' }}</p>
                </div>
            </ig-col>
        </ig-row>

        <ig-row>
            <ig-col [xs]="1">
                <mat-icon>room</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span>{{ event?.isOnlineEvent ? 'Online Event' : (event?.address && event?.address.address || '(no location)') }}</span>
            </ig-col>
        </ig-row>

        <ig-row *ngIf="event?.ticketUri">
            <ig-col [xs]="1">
                <mat-icon>receipt</mat-icon>
            </ig-col>
            <ig-col [xs]="11">
                <span><a href="{{event?.ticketUri}}" target="_blank">{{ event?.ticketUri }}</a></span>
            </ig-col>
        </ig-row>
    </div>

    <!--<div class="join-info" *ngIf="isEventJoined">-->
    <!--<mat-icon>check_box</mat-icon>-->
    <!--<span>You are going to participate in this event!</span>-->
    <!--</div>-->
    <div class="social-btn-group">
        <ig-row>
            <ig-col [xs]="6">
                <ig-button class="dark-blue-btn" (trigger)="shareEventToFacebook()">
                    SHARE
                </ig-button>
            </ig-col>
            <ig-col [xs]="6">
                <ig-button class="red-btn" (trigger)="getDirectionToEventAddress()">GET DIRECTION
                </ig-button>
            </ig-col>
        </ig-row>

        <ig-row>

            <ig-col [xs]="6">
                <ig-button class="ig-blue-btn" (trigger)="tweetEvent()">TWEET
                </ig-button>
            </ig-col>
            <ig-col [xs]="6">
                <ig-button class="orange-btn" (trigger)="mailEvent()">EMAIL
                </ig-button>
            </ig-col>
        </ig-row>
    </div>

    <hr/>

    <div class="event-details-text">
        <p>EVENT DETAILS</p>

        <div class="description">
            <!--{{event?.description}}-->
            <div #description></div>
        </div>
    </div>

    <br>

</ng-template>

<div class="event-details">

    <div class="ig-container-fluid full-height">
        <ig-row class="full-height">
            <ig-col class="side-detail" [md]="3" [xs]="12">
                <ng-container [ngTemplateOutlet]="sidebarTemplate"></ng-container>

                <!--<div style="overflow-y: auto;overflow-x:hidden;position: relative;height: 100%;">-->
                <!---->
                <!--</div>-->
            </ig-col>
            <ig-col class="full-height" [md]="9" *ngIf="!isMobile" [xs]="12">

                <agm-map [styles]="hideIconMapStyler" [latitude]="event?.address?.lat||lat"
                         [longitude]="event?.address?.lng||lng" [zoom]="mapZoom" [fitBounds]="latLngBounds">
                    <agm-marker *ngIf="event?.address.lat&&event?.address.lng" [latitude]="event?.address.lat"
                                [longitude]="event?.address.lng">
                        <agm-snazzy-info-window [isOpen]="true" [closeWhenOthersOpen]="false">
                            <ng-template>
                                <div class="map-event-title">
                                    {{ event?.name || event?.title }}
                                </div>
                                <div class="map-event-img">
                                    <img [src]="imageService.safeImage(imageService.imageSource(event))"
                                         alt="event image">
                                </div>
                                <div class="map-event-time">
                                    <div *ngIf="event?.eventTimes&&event?.eventTimes.length>1">
                                        <p *ngFor="let eventTime of event?.eventTimes">
                                            {{ eventTime.startTimeFormatted }}
                                            {{ eventTime.endTimeFormatted ? ' - ' + eventTime.endTimeFormatted : '' }}
                                        </p>
                                    </div>
                                    <div *ngIf="!event?.eventTimes||event?.eventTimes.length<=1">
                                        <p>{{ event?.startTimeFormatted }}
                                            {{ event?.endTimeFormatted ? ' - ' + event?.endTimeFormatted : '' }}</p>
                                    </div>
                                </div>
                                <ig-button class="event-btn" (trigger)="gotoDetails(event?._id)">DETAILS
                                </ig-button>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>
                    <agm-marker *ngFor="let geo of events" #marker [latitude]="geo.address?.lat"
                                [longitude]="geo.address?.lng" (mouseOver)="showInfoWindow(infoWindow)"
                                (mouseOut)="hideInfoWindow(infoWindow)">
                        <agm-snazzy-info-window #infoWindow [isOpen]="false" [closeWhenOthersOpen]="true"
                                                (onmouseenter)="showInfoWindow(infoWindow)">
                            <ng-template>
                                <div class="map-event-title">
                                    {{ geo.title }}
                                </div>
                                <div class="map-event-img">
                                    <img [src]="imageService.safeImage(imageService.imageSource(geo))" alt="event">
                                </div>
                                <div class="map-event-time">
                                    <div *ngIf="geo.eventTimes&&geo.eventTimes.length">
                                        <ng-container *ngIf="!geo.startTimeText">
                                            <p *ngFor="let eventTime of geo.eventTimes">
                                                {{ eventTime.startTimeFormatted }} - {{ eventTime.startTimeFormatted }}
                                            </p>
                                        </ng-container>

                                        <ng-container *ngIf="geo.startTimeText">
                                            <p *ngFor="let eventTime of geo.eventTimesText">
                                                {{ eventTime.startTimeText + geo.timezone }} -
                                                {{ eventTime.endTimeText + geo.timezone }}
                                            </p>
                                        </ng-container>
                                    </div>
                                    <div *ngIf="!geo.eventTimes||!geo.eventTimes.length">
                                        <p *ngIf="!geo.startTimeText">{{ geo.startTimeFormatted }} -
                                            {{ geo.startTimeFormatted }}</p>
                                        <p *ngIf="geo.startTimeText">{{ geo.startTimeText + geo.timezone }} -
                                            {{ geo.endTimeText + geo.timezone }}</p>
                                    </div>
                                </div>
                                <ig-button class="event-btn" (trigger)="gotoDetails(geo._id)">DETAILS
                                </ig-button>
                            </ng-template>
                        </agm-snazzy-info-window>
                    </agm-marker>
                </agm-map>
            </ig-col>
        </ig-row>
    </div>

</div>
<ig-page-spinner #loadingSpinner></ig-page-spinner>


// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/event.details/visitor.event.details.component.html